import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./coupon-redeemed.page.scss";

const CouponRedeemedPage = () => {
  const history = useHistory();
  const location = useLocation();

  const details = useMemo(() => {
    const params = new URLSearchParams(location.search);

    return {
      organization: params.get("organization") || "your organization",
      course: params.get("course") === "true",
      backgroundcheck: params.get("backgroundcheck") === "true",
      orderId: params.get("order_id"),
    };
  }, [location.search]);

  const redeemedLabel = useMemo(() => {
    if (details.course && details.backgroundcheck) {
      return "Course and Background Check";
    }

    if (details.backgroundcheck) {
      return "Background Check";
    }

    return "Course";
  }, [details.backgroundcheck, details.course]);

  return (
    <div className="coupon-redeemed">
      <div className="coupon-redeemed__card">
        <span className="coupon-redeemed__eyebrow">Coupon Redeemed</span>
        <h1>Your access is ready</h1>
        <p className="coupon-redeemed__lead">
          <strong>{details.organization}</strong> has redeemed{" "}
          <strong>{redeemedLabel}</strong> for your account.
        </p>

        <div className="coupon-redeemed__summary">
          <div className="coupon-redeemed__summary-item">
            <span>Organization</span>
            <strong>{details.organization}</strong>
          </div>
          <div className="coupon-redeemed__summary-item">
            <span>Course Access</span>
            <strong>{details.course ? "Included" : "Not Included"}</strong>
          </div>
          <div className="coupon-redeemed__summary-item">
            <span>Background Check</span>
            <strong>
              {details.backgroundcheck ? "Included" : "Not Included"}
            </strong>
          </div>
        </div>

        <div className="coupon-redeemed__actions">
          {details.course ? (
            <button
              type="button"
              className="cf-navbar__links--link cf-navbar__links--link-primary"
              onClick={() => history.push("/course")}
            >
              Go To Course
            </button>
          ) : null}

          {details.backgroundcheck ? (
            <button
              type="button"
              className="coupon-redeemed__secondary-btn"
              onClick={() =>
                history.push(
                  details.orderId
                    ? `/background?order_id=${encodeURIComponent(details.orderId)}`
                    : "/background",
                )
              }
            >
              Go To Background
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CouponRedeemedPage;
